<template>
  <div class="position-relative h-100 custom-menu overflow-hidden">
    <template v-if="activeFolder">
      <div class="flex h-[44px] items-center justify-between px-3 py-2.5 gap-2.5 border-b border-[#DBDEE6] bg-white">
        <span
          class="w-full cursor-pointer flex items-center text-sm gap-2 text-[#A6A6A6] hover:text-[#44474A] font-semibold mb-0 transition"
          @click="activeFolder = null"
        >
          <svg
            width="15"
            height="10"
            viewBox="0 0 15 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.6 4.77197L1 4.77197"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.5 8.4265L1 4.77209L4.5 1.11768"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Go Back
        </span>
      </div>

      <div class="flex items-start justify-between px-3 py-2.5 gap-2.5 border-b border-[#DBDEE6] bg-[#F2F4F5]">
        <span
          class="w-full flex items-center text-sm gap-2 text-[#44474A] font-semibold mb-0 transition"
        >
          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-[18px] h-[18px]"
          >
            <path
              d="M10.9688 5.90625L10.0275 4.02377C9.75662 3.48199 9.62117 3.21108 9.41909 3.01317C9.24039 2.83815 9.02502 2.70504 8.78856 2.62348C8.52117 2.53125 8.2183 2.53125 7.61256 2.53125H4.3875C3.44241 2.53125 2.96987 2.53125 2.60889 2.71518C2.29137 2.87696 2.03321 3.13512 1.87143 3.45264C1.6875 3.81362 1.6875 4.28616 1.6875 5.23125V5.90625M1.6875 5.90625H14.5125C15.9301 5.90625 16.6389 5.90625 17.1804 6.18214C17.6567 6.42482 18.0439 6.81205 18.2866 7.28834C18.5625 7.8298 18.5625 8.53862 18.5625 9.95625V13.6687C18.5625 15.0864 18.5625 15.7952 18.2866 16.3367C18.0439 16.8129 17.6567 17.2002 17.1804 17.4429C16.6389 17.7187 15.9301 17.7188 14.5125 17.7188H5.7375C4.31987 17.7188 3.61105 17.7187 3.06959 17.4429C2.5933 17.2002 2.20607 16.8129 1.96339 16.3367C1.6875 15.7952 1.6875 15.0864 1.6875 13.6687V5.90625ZM7.59375 11.8125L10.125 14.3438M10.125 14.3438L12.6562 11.8125M10.125 14.3438V9.28125"
              stroke="#6E747A"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          {{ activeFolder.name }}
        </span>
      </div>
    </template>

    <div
      v-else
      class="flex h-[44px] items-start justify-between px-3 py-2.5 gap-2.5 border-b border-[#DBDEE6] bg-white"
    >
      <span class="text-base text-[#44474A] font-semibold mb-0">
        Favorites
      </span>

      <button
        class="flex items-center justify-center w-6 h-6 p-0 bg-white rounded-full text-primary hover:opacity-60 hover:bg-gray-200 transition"
        @click="folderModal = true"
      >
        <svg
          width="19"
          height="15"
          viewBox="0 0 19 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
        >
          <path
            d="M15.18 10.785V14.3375H13.6575V10.785H10.5075V9.4025H13.6575V5.99H15.18V9.4025H18.3125V10.785H15.18Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.9234 4.02319C17.0601 4.02319 17.1903 4.08201 17.2814 4.18495C17.3726 4.28788 17.4161 4.42515 17.4011 4.56241L17.3532 5.00003H16.3862L16.3867 4.99491H3.7949L2.06998 13.4784H11V14.45H1.48059C1.33615 14.45 1.19941 14.3844 1.10813 14.2712C1.03691 14.1829 0.999712 14.073 1.00058 13.961L1 1.26587C1 0.997557 1.21517 0.780029 1.48059 0.780029H5.83915C6.10456 0.780029 6.31973 0.997557 6.31973 1.26587V1.84564H14.5678C14.8332 1.84564 15.0484 2.06317 15.0484 2.33149V4.02319H16.9234ZM5.35857 1.75172H1.96118V9.18761L2.93235 4.41122C2.97826 4.1853 3.17495 4.02319 3.40307 4.02319H14.0872V2.81733H5.83916C5.57375 2.81733 5.35857 2.5998 5.35857 2.33149V1.75172Z"
            fill="currentColor"
          />
          <path
            d="M17.2814 4.18495L17.3937 4.0855L17.3937 4.08548L17.2814 4.18495ZM17.4011 4.56241L17.252 4.54609V4.5461L17.4011 4.56241ZM17.3532 5.00003V5.15003H17.4877L17.5023 5.01635L17.3532 5.00003ZM16.3862 5.00003L16.2371 4.98373L16.2189 5.15003H16.3862V5.00003ZM16.3867 4.99491L16.5358 5.01122L16.554 4.84491H16.3867V4.99491ZM3.7949 4.99491V4.84491H3.67233L3.6479 4.96502L3.7949 4.99491ZM2.06998 13.4784L1.92298 13.4485L1.88641 13.6284H2.06998V13.4784ZM11 13.4784H11.15V13.3284H11V13.4784ZM11 14.45V14.6H11.15V14.45H11ZM1.10813 14.2712L1.22489 14.177L1.22487 14.177L1.10813 14.2712ZM1.00058 13.961L1.15058 13.9622L1.15058 13.961L1.00058 13.961ZM1 1.26587H0.85V1.26588L1 1.26587ZM6.31973 1.84564H6.16973V1.99564H6.31973V1.84564ZM15.0484 4.02319H14.8984V4.17319H15.0484V4.02319ZM1.96118 1.75172V1.60172H1.81118V1.75172H1.96118ZM5.35857 1.75172H5.50857V1.60172H5.35857V1.75172ZM1.96118 9.18761H1.81118L2.10817 9.21749L1.96118 9.18761ZM2.93235 4.41122L3.07934 4.44111L3.07934 4.44109L2.93235 4.41122ZM14.0872 4.02319V4.17319H14.2372V4.02319H14.0872ZM14.0872 2.81733H14.2372V2.66733H14.0872V2.81733ZM17.2814 4.18495L17.3937 4.08548C17.2743 3.95064 17.1033 3.87319 16.9234 3.87319V4.02319V4.17319C17.0168 4.17319 17.1062 4.21338 17.1692 4.28441L17.2814 4.18495ZM17.4011 4.56241L17.5502 4.57874C17.5698 4.39962 17.5131 4.22026 17.3937 4.0855L17.2814 4.18495L17.1691 4.28439C17.2321 4.3555 17.2624 4.45067 17.252 4.54609L17.4011 4.56241ZM17.3532 5.00003L17.5023 5.01635L17.5502 4.57873L17.4011 4.56241L17.252 4.5461L17.2041 4.98371L17.3532 5.00003ZM16.3862 5.00003V5.15003H17.3532V5.00003V4.85003H16.3862V5.00003ZM16.3862 5.00003L16.5353 5.01634L16.5358 5.01122L16.3867 4.99491L16.2376 4.97861L16.2371 4.98373L16.3862 5.00003ZM16.3867 4.99491V4.84491H3.7949V4.99491V5.14491H16.3867V4.99491ZM3.7949 4.99491L3.6479 4.96502L1.92298 13.4485L2.06998 13.4784L2.21697 13.5083L3.94189 5.0248L3.7949 4.99491ZM2.06998 13.4784V13.6284H11V13.4784V13.3284H2.06998V13.4784ZM11 14.45H11.15V13.4784H11H10.85V14.45H11ZM1.48059 14.45V14.6H11V14.45V14.3H1.48059V14.45ZM1.10813 14.2712L0.991377 14.3654C1.11091 14.5136 1.29044 14.6 1.48059 14.6V14.45V14.3C1.38186 14.3 1.28791 14.2552 1.22489 14.177L1.10813 14.2712ZM1.00058 13.961L0.850581 13.9599C0.849455 14.1058 0.8979 14.2495 0.991398 14.3654L1.10813 14.2712L1.22487 14.177C1.17592 14.1164 1.14997 14.0403 1.15057 13.9622L1.00058 13.961ZM1 1.26587L0.85 1.26588L0.850577 13.9611L1.00058 13.961L1.15058 13.961L1.15 1.26587L1 1.26587ZM1.48059 0.780029V0.630029C1.1308 0.630029 0.85 0.916257 0.85 1.26587H1H1.15C1.15 1.07886 1.29955 0.930029 1.48059 0.930029V0.780029ZM5.83915 0.780029V0.630029H1.48059V0.780029V0.930029H5.83915V0.780029ZM6.31973 1.26587H6.46973C6.46973 0.916258 6.18894 0.630029 5.83915 0.630029V0.780029V0.930029C6.02018 0.930029 6.16973 1.07886 6.16973 1.26587H6.31973ZM6.31973 1.84564H6.46973V1.26587H6.31973H6.16973V1.84564H6.31973ZM14.5678 1.84564V1.69564H6.31973V1.84564V1.99564H14.5678V1.84564ZM15.0484 2.33149H15.1984C15.1984 1.98187 14.9176 1.69564 14.5678 1.69564V1.84564V1.99564C14.7488 1.99564 14.8984 2.14447 14.8984 2.33149H15.0484ZM15.0484 4.02319H15.1984V2.33149H15.0484H14.8984V4.02319H15.0484ZM16.9234 4.02319V3.87319H15.0484V4.02319V4.17319H16.9234V4.02319ZM1.96118 1.75172V1.90172H5.35857V1.75172V1.60172H1.96118V1.75172ZM1.96118 9.18761H2.11118V1.75172H1.96118H1.81118V9.18761H1.96118ZM2.93235 4.41122L2.78536 4.38133L1.81419 9.15772L1.96118 9.18761L2.10817 9.21749L3.07934 4.44111L2.93235 4.41122ZM3.40307 4.02319V3.87319C3.10253 3.87319 2.84525 4.0866 2.78535 4.38135L2.93235 4.41122L3.07934 4.44109C3.11127 4.284 3.24737 4.17319 3.40307 4.17319V4.02319ZM14.0872 4.02319V3.87319H3.40307V4.02319V4.17319H14.0872V4.02319ZM14.0872 2.81733H13.9372V4.02319H14.0872H14.2372V2.81733H14.0872ZM5.83916 2.81733V2.96733H14.0872V2.81733V2.66733H5.83916V2.81733ZM5.35857 2.33149H5.20857C5.20857 2.6811 5.48937 2.96733 5.83916 2.96733V2.81733V2.66733C5.65812 2.66733 5.50857 2.5185 5.50857 2.33149H5.35857ZM5.35857 1.75172H5.20857V2.33149H5.35857H5.50857V1.75172H5.35857Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>

    <div
      v-if="loading"
      class="d-flex align-items-center justify-content-center h-100 min-h-[300px]"
    >
      <b-spinner variant="primary" />
    </div>
    <div
      v-else
      class="flex flex-col max-h-[600px] h-[calc(100vh-160px)] overflow-y-scroll"
    >
      <FavoritesFolder
        v-for="category in categories"
        v-if="!activeFolder"
        :key="`folder-${category.id}`"
        :folder="category"
        @edit="editFolder"
        @delete="deleteFolder"
        @click="activeFolder = $event"
      />
      <draggable
        :key="`draggable-${activeFolder ? activeFolder.id : 'root'}-${favorites.length}`"
        v-model="blocks"
        :clone="cloneBlock"
        :group="{ name: group, pull: 'clone', put: false }"
        :sort="false"
        handle=".move"
        :scroll="true"
        :force-fallback="true"
        :fallback-class="`${group}-sortable-fallback`"
        :force-autoscroll-fallback="true"
        :scroll-sensitivity="60"
        :bubble-scroll="true"
        :fallback-on-body="true"
        :item-key="'id'"
        @choose="setGroup"
      >
        <FavoritesItem
          v-for="(favorite, index) in blocks"
          :key="`favorite-${favorite.id || favorite.hash || (favorite.block && (favorite.block.uid || favorite.block.render_id))}`"
          :favorite="favorite"
          :index="index"
          :data-group="favorite.block.group"
          @regenerate-hash="fetchFavorites"
          @move-to-folder="moveToFolder"
        />
      </draggable>
    </div>

    <FavoriteFolderModal
      v-model="folderModal"
      :folder="folderManage"
      @success="fetchFavorites"
    />

    <b-modal
      v-model="moveToFolderModal"
      class="position-relative"
      lazy
      centered
      body-class="py-5"
      content-class="new-section-modal"
      size="lg"
      hide-footer
      hide-header
    >
      <h3 class="text-center font-weight-bold mb-12 px-0">
        Move Global Variable to Folder
      </h3>

      <b-row>
        <b-col
          offset="2"
          cols="8"
        >
          <b-form @submit.prevent="onMoveToFolder">
            <b-form-group
              class="estage-form-group"
              label="Folder"
              label-class="font-medium"
            >
              <v-select
                v-model="folder"
                :options="[
                  {
                    key: null,
                    name: 'Select Folder'
                  },
                  ...categories
                ]"
                label="name"
                placeholder="Select Folder"
              />
            </b-form-group>

            <div class="text-center mt-5">
              <b-btn
                type="submit"
                variant="primary"
                class="font-weight-bold font-size-14 px-5"
                :disabled="loading"
              >
                Move to Folder
                <b-spinner
                  v-if="loading"
                  class="ml-2 mt-1"
                  variant="light"
                  small
                />
              </b-btn>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {mapState} from 'vuex'
import shortid from 'shortid'
import TextMixins from '../../mixins/TextMixins'
import elements from '@builder/components/builder/elements'
import FavoritesItem from '@/components/editor/navigation/FavoritesItem.vue'
import FavoriteFolderModal from '@/components/editor/modals/FavoriteFolderModal.vue'
import FavoritesFolder from '@/components/editor/navigation/FavoritesFolder.vue'

export default {
  name: 'Favorites',
  components: {
    FavoritesFolder,
    FavoriteFolderModal,
    FavoritesItem,
    draggable
  },
  mixins: [TextMixins],
  data () {
    return {
      group: null,
      loading: false,
      copied: false,
      activeFolder: null,
      folderModal: false,
      folderManage: null,
      moveToFolderModal: false,
      moveToFolderManage: null,
      folder: null
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    ...mapState('favorites', {
      favorites: state => state.favorites,
      categories: state => state.categories
    }),
    ...mapState('auth', {
      user: state => state.user
    }),
    elements () {
      return elements
    },
    blocks () {
      if (this.activeFolder) {
        return this.favorites.filter(f => f.category_id === this.activeFolder.id)
      }
      return this.favorites.filter(f => f.category_id === null || f.category_id === 0 || f.category_id === undefined)
    }
  },
  methods: {
    async fetchFavorites () {
      this.loading = true
      this.folderManage = null
      try {
        await this.$store.dispatch('favorites/fetchFavorites')
        await this.$store.dispatch('favorites/fetchFavoritesCategories')
        const globalCategories = this.favorites.map(f => f.category).filter(f => f !== null && f.id !== 0)
        await this.$store.dispatch('favorites/setCategories', globalCategories)
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async editFolder (folder) {
      this.folderModal = true
      this.folderManage = folder
    },
    async deleteFolder (folder) {
      this.loading = true
      await axios.delete(`api/projects/${this.project.id}/favorite-blocks/categories/${folder.id}`)
        .then(async () => {
          await this.fetchFavorites()
          this.$swal({
            icon: 'success',
            title: 'Success!',
            text: 'The folder has been successfully deleted',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Server error',
            text: 'Please try again later or let us know about your problem.',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 250)
        })
    },
    async moveToFolder (favorite) {
      this.moveToFolderModal = true
      this.moveToFolderManage = favorite
    },
    async onMoveToFolder () {
      if (!this.moveToFolderManage) return
      const block = this.moveToFolderManage.block
      const content = JSON.stringify(block)
      this.loading = true

      await axios.put(`api/projects/${this.project.id}/favorite-blocks/${this.moveToFolderManage.id}?set_global=${block.isGlobal}`, {
        block: content,
        sharable: block.isSharable,
        category_id: this.folder?.id || undefined
      })
        .then(async () => {
          this.folder = null
          this.moveToFolderModal = false
          await this.fetchFavorites()
          this.$swal({
            icon: 'success',
            title: 'Success!',
            text: 'The favorite block has been successfully moved',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch(() => {
          this.$swal({
            icon: 'error',
            title: 'Server error',
            text: 'Please try again later or let us know about your problem.',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    copyHash (hash) {
      this.copied = true
      navigator.clipboard.writeText(hash)

      setTimeout(() => {
        this.copied = false
      }, 1000)
    },
    globalFavorite (favorite) {
      this.loading = favorite.id
      return this.$store.dispatch('favorites/addToGlobal', {favorite, inSharable: favorite.inSharable, inGlobal: favorite.user_id})
        .then(() => {
          if (!favorite.user_id) {
            return this.$set(favorite, 'user_id', this.user.id)
          }

          this.$set(favorite, 'user_id', 0)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cloneBlock ({block}) {
      block.section.css = block.css
      block.section.sids = block.sids
      block.section.uid = shortid.generate()
      block.section.render_id = shortid.generate()

      return {
        ...block.section,
        uid: shortid.generate(),
        render_id: shortid.generate()
      }
    },
    setGroup (evt) {
      this.group = evt.item.getAttribute('data-group')
    }
  },
  async created () {
    await this.fetchFavorites()
  }
}
</script>

<style lang="scss">
.delete-favorite-icon {
  right: 23px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
